import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/gifts")({
  component: lazyRouteComponent(() => import("./-pages/admin.gifts")),
  head: () => ({ meta: [{ title: "Admin · Gift Programs — Lecmo" }] }),
});
